<template>
  <div>
    <!-- Modal -->
    <div
      class="modal fade"
      :id="modal_id"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Anexar Arquivos
              <span class="badge badge-secondary mx-2" v-if="parms">
                {{ parms.model_id }}
              </span>
              <span class="badge badge-dark" v-if="traduzir_modelo()">
                {{ traduzir_modelo() }}
              </span>
            </h5>
            <button type="button" class="close" @click="fechar()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="exibe_body">

            <div v-if="modal_info_model" class="small text-muted">{{ modal_info_model }}</div>

            <!-- WebCam -->
            <div class="border" v-if="usewebcam">
              <div class="row">
                <div class="col-md-6">
                    <code v-if="device">{{ device.label }}</code>
                    <div class="border">
                        <vue-web-cam
                            ref="webcam"
                            :device-id="deviceId"
                            width="100%"
                            @started="onStarted"
                            @stopped="onStopped"
                            @error="onError"
                            @cameras="onCameras"
                            @camera-change="onCameraChange"
                        />
                    </div>
                </div>
                <div class="col-md-6 d-flex flex-column justify-content-between">
                    <code v-if="device">Imagem Capturada</code>
                    <figure class="figure">
                        <img :src="img" class="img-responsive figure-img img-fluid rounded" />
                    </figure>
                    <div>
                      <select v-model="camera" class="form form-control">
                          <option>-- Selecione a fonte de vídeo --</option>
                          <option v-for="device in devices" :key="device.deviceId" :value="device.deviceId">{{ device.label }}</option>
                      </select>
                      <div class="d-flex flex-column">
                        <div class="btn-group" role="group" aria-label="Basic example">
                          <button type="button" class="btn btn-success" @click="onStart" v-if="!opencam" title="Iniciar">
                            <i class="fa fa-play"></i>
                          </button>
                          <button type="button" class="btn btn-danger" @click="onStop" v-else title="Parar">
                            <i class="fas fa-stop"></i>
                          </button>
                          <button type="button" class="btn btn-dark" @click="onCapture" v-if="opencam" title="Capturar">
                            <i class="fas fa-camera"></i>
                          </button>
                          <button type="button" class="btn btn-dark" @click="onCaptureSelect" v-if="opencam" title="Capturar e selecionar">
                            <i class="fa-solid fa-camera-rotate"></i>
                          </button>
                          <button type="button" class="btn btn-dark" @click="onCaptureSelectSend" v-if="opencam" title="Capturar, selecionar e enviar">
                            <i class="fa-solid fa-cloud-arrow-up"></i>
                          </button>
                          <button type="button" class="btn btn-primary" @click="selecionarCaptura" :disabled="!img" v-if="opencam" title="Selecionar">
                            <i class="fas fa-mouse-pointer"></i>
                            <span class="badge badge-light ml-2" v-if="cont_captura">
                              {{ cont_captura }}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                </div>
              </div>

            </div>

            <!-- QRCode pelo Celular -->
            <div class="example-simple" v-else-if="qrCode">
              <div class="card border-0 card-templates shadow-lg card-link">
                <div class="card-body text-center bg-light">
                  
                  <qr-code :text="qrCode" :size="200" class="d-flex justify-content-center my-3"></qr-code>
                  
                  <div class="text-center">
                    Aponte a câmera do seu celular para o <a href="#" @click.prevent="copiar_clipboard(qrCode)" class="card-link text-dark">QRCODE</a>.
                  </div>

                </div>
              </div>
            </div>
            <div class="example-simple">
              <div class="upload">
                <az-file-upload-items 
                    ref="file_items"
                    :files="files" 
                    :exibirInfo="!usewebcam" 
                    :model="parms ? parms.model_type : ''" 
                    :anexar_mult="anexar_mult" />

                <div class="example-btn">

                    <div class="row" v-if="model && model.id_laudo">
                        <div class="col col-12">
                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Imprimir imagens chave no laudo"
                                v-model="model.fl_imp_keys" />
                        </div>
                    </div>
                    
                    <!-- :size="1024 * 1024 * 10" -->

                    <div class="progress mt-1 mb-1">
                        <div class="indeterminate" v-if="$store.state.loading"></div>
                        <div class="determinate" v-else></div>
                    </div>

                    <ul class="list-group mt-2" v-if="arquivos">
                        <li class="list-group-item" v-for="(arq, ia) in arquivos" :key="ia">
                            <template v-if="arq.arquivo">
                                <div class="form-row">
                                    <div class="col col-1 text-center" v-if="usewebcam">
                                        <figure class="figure mb-0" v-if="getIcon(arq.arquivo.st_titulo) == 'file-image'">
                                            <a :href="arq.arquivo.temporary_url" target="_blank">
                                                <img :src="arq.arquivo.temporary_url" class="figure-img img-fluid rounded mb-0" style="max-height: 36px; max-width: 48px;">
                                            </a>
                                        </figure>
                                    </div>
                                    <div class="col col-12" :class="calc_col_size()">
                                        <div class="text-truncate">
                                            <a :href="arq.arquivo.temporary_url" target="_blank" class="card-link">
                                                {{ arq.arquivo.st_titulo }}
                                                <span class="badge badge-light small ml-1" v-if="arq.arquivo && arq.arquivo.tipo && arq.arquivo.tipo.st_sigla">
                                                    {{ arq.arquivo.tipo.st_sigla ? arq.arquivo.tipo.st_sigla : ''}}
                                                </span>
                                            </a>
                                        </div>
                                        <div class="text-muted small" v-if="arq.arquivo.st_descricao">
                                            {{ arq.arquivo.st_descricao }}
                                        </div>
                                        <div v-if="arq.dt_validade" class="small" :class="( arq.dt_validade < $util.hoje() || arq.fl_revogado ) ? 'text-danger' : 'text-muted'">
                                            Validade: {{ $util.getFormatDate(arq.dt_validade) }}, {{ $util.getHumanDuration(arq.dt_validade) }}
                                            <span v-if="arq.fl_revogado" class="badge badge-danger ml-1">Revogado</span>
                                        </div>
                                        <div v-if="arq.arquivo.created_at && arq.arquivo.inf" class="small text-muted">
                                            em
                                            {{ $util.getFormatDate(arq.arquivo.created_at) }}
                                            {{ arq.arquivo.created_at.substr(11,5) }}
                                        </div>

                                        <az-input
                                            v-if="arq.edit_tipo"
                                            sizing="sm"
                                            type="select"
                                            optionsMode="aql"
                                            optionsData="id_tipo_arquivo"
                                            optionsDisplay="st_descricao"
                                            :optionsName="'tipos_arquivo.index.' + arq.model_type.split('\\').pop()"
                                            service="tipo_arquivos.index"
                                            :optionsParm="{ fl_ativo: 1, model: arq.model_type.split('\\').pop() }"
                                            placeholder="Selecionar o tipo de arquivo..."
                                            v-model="arq.id_tipo_edicao">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-success" type="button" title="Atualizar" @click="atualizar_tipo(arq)" :disabled="!arq.id_tipo_edicao || $store.state.loading">
                                                        <i class="fa-solid fa-check"></i>
                                                    </button>
                                                </div>  
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-4 text-right" v-if="$store.state.user && $store.state.user.st_tipo == 'U'">
                                        <a href="#" @click.prevent="ocerizar_pedido(arq.arquivo)" 
                                            v-if="( arq.model_type == 'App\\azure\\marcacao' || arq.model_type == 'App\\azure\\orcamento' ) && arq.arquivo.tipo && arq.arquivo.tipo.fl_pedido" 
                                            title="Verificar Exames">
                                            <i class="fa-solid fa-wand-magic-sparkles ml-3"></i>
                                        </a>
                                        <a href="#" @click.prevent="diagnostico_inteligente_pedido(arq.arquivo)" v-if="false && arq.arquivo.created_at && $store.state.user.id_usuario == 1" title="Diagnóstico inteligente.">
                                            <i class="fa-solid fa-brain ml-3"></i>
                                        </a>

                                        <a href="#" @click.prevent="editar_tipo(arq)" title="Editar Tipo de Arquivo.">
                                            <i class="fa-solid fa-pen-to-square ml-3"></i>
                                        </a>

                                        <a :href="get_download_link_jpg(arq)"
                                            class="card-link m-0" v-if="arq.arquivo.st_token && arq.arquivo.st_titulo.slice(0,4) == 'lea_' && arq.arquivo.st_tipo_arquivo == 'pdf'"
                                            title="Baixar arquivo no formato JPG"
                                            target="_blank">
                                            <i class="fa-solid fa-file-image ml-3"></i>
                                        </a>

                                        <a href="#" @click.prevent="toggle_nopep(arq)"
                                            class="card-link m-0" :class="arq.st_tipo_especial == 'nopep' ? 'text-muted' : 'text-primary'" 
                                            v-if=" ( arq.model_type == 'App\\azure\\marcacao' || arq.model_type == 'App\\azure\\pessoa' )
                                            && ( !arq.st_tipo_especial || arq.st_tipo_especial != 'pep' )"
                                            :title="( arq.st_tipo_especial == 'nopep' ? 'Não Exibir' : 'Exibir' ) + ' na galeria de imagens do prontuário.'">
                                            <i class="fas fa-images ml-3"></i>
                                        </a>

                                        <a href="#" @click.prevent="toggle_lock(arq)" class="card-link m-0 ml-3" 
                                            v-if="arq.model_type == 'App\\azure\\anamnese' && arq.arquivo.id_usuario == $store.state.user.id_usuario"
                                            :title="( arq.st_tipo_especial == 'locked' ? 'Acesso restrito para mim ' : 'Acesso disponível ' ) + ' na galeria de imagens do prontuário.'">
                                            <i class="fa-solid fa-lock" v-if="arq.st_tipo_especial == 'locked'"></i>
                                            <i class="fa-solid fa-lock-open text-muted" v-else></i>
                                        </a>

                                        <a href="#" @click.prevent="editar_validade(arq)" class="card-link m-0 text-primary ml-3" v-if="tem_validade || ( arq.arquivo.tipo && arq.arquivo.tipo.fl_tem_validade )" title="Validade do Arquivo.">
                                            <i class="fa-regular fa-calendar-check"></i>
                                        </a>

                                        <a href="#" @click.prevent="compartilhar(arq)" class="card-link m-0 text-success" v-if="parms.id_paciente && !parms.token" title="Enviar para o paciente.">
                                            <i class="fas fa-share ml-3" aria-hidden="true"></i>
                                        </a>

                                        <a href="#" @click.prevent="atualizar_key(arq)" class="card-link m-0" :class="arq.fl_key ? 'text-primary' : 'text-muted'" v-if="parms.model_type == 'laudo'" title="Remover anexo.">
                                            <i class="fa-solid fa-key"></i>
                                        </a>

                                        <a href="#" @click.prevent="remover_anexo(arq)" class="card-link m-0 text-danger" v-if="!parms.token && !viewonly" title="Remover anexo.">
                                            <i class="fa fa-trash-o ml-3" aria-hidden="true"></i>
                                        </a>
                                        <a href="#" @click.prevent="arq.arquivo.inf = !arq.arquivo.inf" class="card-link m-0 text-success" v-if="arq.arquivo.created_at" title="Informações.">
                                            <i class="fa-solid fa-circle-info ml-3"></i>
                                        </a>
                                        <az-audit-log-button class="ml-2" model="arquivoLink" :id="arq.id_arquivo_link" :link="true" sizing="sm" v-if="!viewonly" />
                                    </div>
                                </div>
                            </template>
                        </li>
                    </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex">
              <template v-if="viewonly">
                <button type="button" class="btn btn-primary mb-lg-0 mb-2" @click.prevent="ver_conteudo()" title="Ver Conteúdo">
                  <i class="fa-regular fa-images"></i>
                  Ver Conteúdo
                </button>
                <button type="button" class="btn btn-secondary mb-lg-0 mb-2" @click="fechar()">
                    Fechar
                </button>
              </template>

              <template v-else>
                <template v-if="!blockcelular">
                  <button type="button" class="btn btn-primary" @click.prevent="ver_conteudo()" title="Ver Conteúdo">
                    <span class="d-block d-lg-none"><i class="fa-regular fa-images"></i></span>
                    <span class="d-none d-lg-block"><i class="fa-regular fa-images mr-1"></i> Ver Conteúdo</span>
                  </button>
                  <button type="button" class="btn btn-primary" @click="ver_conteudo(true)" title="Conteúdo na lateral">
                    <i class="fa-solid fa-right-to-line"></i>
                  </button>
                  <button type="button" class="btn btn-warning" @click.prevent="incluir_link()" title="Link">
                    <span class="d-block d-lg-none"><i class="fa-solid fa-link"></i></span>
                    <span class="d-none d-lg-block"><i class="fa-solid fa-link mr-1"></i>Link</span>
                  </button>
                  <button type="button" class="btn btn-warning" @click.prevent="usewebcam = !usewebcam;" title="Capturar">
                    <span class="d-block d-lg-none"><i class="fas fa-camera"></i></span>
                    <span class="d-none d-lg-block"><i class="fas fa-camera mr-1"></i>Capturar</span>
                  </button>
                  <button type="button" class="btn btn-warning" @click.prevent="obterQrCode()" v-if="$store.state.user" title="Usar o Celular">
                    <span class="d-block d-lg-none"><i class="fa fa-qrcode"></i></span>
                    <span class="d-none d-lg-block"><i class="fa fa-qrcode mr-1"></i>Celular</span>
                  </button>
                </template>
                <file-upload
                  class="btn btn-primary"
                  post-action="https://api.klingo.app/api/upload_arquivo_token"
                  :extensions="extensions ? extensions : 'gif,jpg,jpeg,png,webp,tif,tiff,pdf,docx,xlsx,xml,csv,txt,zip'"
                  accept="image/png,image/gif,image/jpeg,image/tiff,image/webp,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/xml,text/csv,text/plain,application/zip"
                  :input-id="'file' + modal_id"
                  :name="'file' + modal_id"
                  :headers="{ ...this.axios.defaults.headers.post }"
                  :multiple="multiple ? true : false"
                  :size="1024 * 1024 * 10 || 0"
                  :custom-action="azUpload"
                  v-model="files"
                  @input-filter="inputFilter"
                  @input-file="inputFile"
                  ref="upload">
                  <span class="d-block d-lg-none"><i class="fa fa-plus"></i></span>
                  <span class="d-none d-lg-block"><i class="fa fa-plus mr-1"></i>Arquivos</span>
                </file-upload>

                <button type="button" class="btn btn-secondary d-none d-sm-block" @click="fechar()">
                  Fechar
                </button>
                <button type="button" class="btn btn-success" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="enviar_anexos()">
                  Enviar
                </button>
                <button type="button" class="btn btn-danger" v-else @click.prevent="$refs.upload.active = false">
                  <i class="fa fa-stop" aria-hidden="true"></i>
                  Parar Envio
                </button>
              </template>
          </div>
        </div>
      </div>
    </div>

    <view-anexos-preview ref="preview" @refresh="$emit('refresh')" /> <!-- @refresh="refresh_view" -->
    <ocerizar-pedido :modal_id="modal_id" ref="ocr" @refresh="repassar_ocr" />
    <validade-arquivo ref="validarq" :modal_name="modal_id" @refresh="$emit('refresh')" />
  </div>
</template>

<script>
// import AzInput from "../shared/forms/AzInput.vue";
import AzFileUploadItems from "./AzFileUploadItems";
import $ from "jquery";
import _ from "lodash";
import { subscribe } from "../../service/Notify";
import { WebCam } from "vue-web-cam";
import ViewAnexosPreview from '../shared/gallery/ViewAnexosPreview.vue';
import AzAuditLogButton from '../util/AzAuditLogButton.vue';
import OcerizarPedido from '../util/OcerizarPedido.vue';
import ValidadeArquivo from './ValidadeArquivo.vue';
import AzInput from '../shared/forms/AzInput.vue';

export default {
  data: function() {
    return {
      files: [],
      qrCode: null,
      canal: null,
      usewebcam: false,

      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      opencam: false,

      cont_captura: 0,
      chave_modal: "",
      exibe_body: false, 
    };
  },

  components: {
    AzFileUploadItems,
    ViewAnexosPreview,
    AzAuditLogButton,
    OcerizarPedido, 
    ValidadeArquivo,
    AzInput, 
    "vue-web-cam": WebCam,
  },

  props: ["parms", "arquivos", "multiple", "blockcelular", "extensions", "tem_validade", "viewonly", "model", "anexar_mult"],

  computed: {
    envio_individual: function() { 

        let tamanho_acc = this.files.reduce((total, carry) => {
            return total + carry.file.size;
        }, 0); 

        return ( tamanho_acc > ( 1024 * 1024 * 10 ) ) ? true : false;

    },

    modal_id: function () {
      return 'fileUploadModal'
        + ( this.parms ? _.get(this.parms, 'model_type') : '' )
        + ( this.parms ? _.get(this.parms, 'model_id') : '' )
        + this.chave_modal ;
    },

    modal_info_model: function () { 
      if ( this.parms && this.parms.model_type == 'pessoa' ) { 
        return 'Arquivos do Paciente. Ficarão disponíveis em outros atendimentos desse paciente.';
      }

      if ( this.parms && this.parms.model_type == 'marcacao' ) { 
        return 'Arquivos do Atendimento. Ficam disponíveis vinculados a esse atendimento.';
      }

      return '';
    }, 

    device: function() {
        return this.devices.find(n => n.deviceId === this.deviceId);
    },
  },

  watch: {
      camera: function(id) {
          this.deviceId = id;
      },
      devices: function() {
          // Once we have a list select the first one
          const [first, ...tail] = this.devices;
          if (first) {
              this.camera = first.deviceId;
              this.deviceId = first.deviceId;
          }
          console.log(tail);
      }
  },

  methods: {
    atualizar_tipo (arq) { 
        this.$util.atualizar(this, { 
            service: 'arquivos', 
            func: 'atualizar_tipo', 
            dados: { 
                id_arquivo: arq.id_arquivo,
                id_tipo_arquivo: arq.id_tipo_edicao
            },
            toast: true, 
            callback: () => { 
                this.$emit('refresh', arq.id_arquivo_link);
            }
        });
    },

    editar_tipo (arq) { 
        arq.id_tipo_edicao = arq.arquivo.id_tipo_arquivo ? arq.arquivo.id_tipo_arquivo : "";
        arq.edit_tipo = !arq.edit_tipo; 

        this.$forceUpdate(); 
    },  

    calc_col_size() { 
        let cols = ( this.$store.state.user && this.$store.state.user.st_tipo == 'U' ) ? 7 : 11; 

        if ( !this.usewebcam ) { 
            cols ++; 
        }

        return 'col-md-' + cols; 
    },

    atualizar_imp_keys () { 

        this.$nextTick(() => { 
            setTimeout(() => { 
                this.$util.atualizar(this, { 
                    service: 'laudos',
                    func: 'set_imprimir_imagens_chave',
                    dados: _.map(this.model, ( item ) => { 
                        return { 
                            id_laudo: item.id_laudo,
                            fl_imp_keys: item.fl_imp_keys
                        };
                    }),
                }),
                200
            });
        });

    },


    atualizar_key(arquivo_link) { 
        arquivo_link.fl_key = !arquivo_link.fl_key;

        this.$util.atualizar(this, { 
            service: 'arquivo_links',
            dados: arquivo_link, 
            callback: () => { 
                this.$emit('refresh', arquivo_link.id_arquivo_link);
            }
        });
    },

    traduzir_modelo() { 
      if ( !this.parms || !this.parms.model_type ) { 
        return;
      }

      switch (this.parms.model_type) {
        case 'cadastroTemporario': return 'Pré-Cadastro Paciente';
        case 'pessoa': return 'Paciente';
        case 'marcacao': 
          return this.parms.id_atendimento ? 'Atendimento' : 'Marcação/Atendimento';
          
        case 'solicitacaoAutorizacao': return 'Solicitação de Autorização';
        case 'laudo': return 'Laudo';
        case 'anamnese': return 'Prontuário';
      }

      return '';
    },

    editar_validade(arquivo) { 
      this.$refs.validarq.abrir(arquivo);
    },

    copiar_clipboard (texto) { 
      this.$util.copiar_clipboard(this, texto);
    },

    repassar_ocr (ocr) { 
      this.$emit('ocr', ocr);
    }, 

    ocerizar_pedido (arquivo) { 
      this.$refs.ocr.ocerizar_pedido(arquivo);
    },

    async diagnostico_inteligente_pedido(arquivo) {
        let query = { q: [
            {
                name: "marcacoes.show",
                id: "marcacao",
                parms: {
                    id: this.parms.model_id,
                }
            }
        ]};

        const axiosMarcacao = await  this.axios.post('/aql?=cmarcacoes.show', query);
        const marcacao = axiosMarcacao.data.marcacao.data;
        
        const dateStr = marcacao.cadastro_temporario.dt_nascimento;
        const formattedDate = new Date(dateStr).toLocaleDateString("pt-BR");

        const paciente = {
            'data_de_nascimento': formattedDate,
            'genero': marcacao.cadastro_temporario.sexo.toLowerCase(),
        }

        const body = {
            "id_arquivo": arquivo.id_arquivo,
            "name": arquivo.st_titulo,
            "mime": "application/pdf",
            "paciente": paciente,
            "output": "df-pdf.df-pdf.docx.pdf",
            "unknown": true
        }

        let queryInia = { q: [
            {
                name: 'inia_ia.get_diagnostico',
                id: 'get_diagnostico',
                parms: {
                    ...body,
                }
            },
        ]};

        this.$store.commit('loading', true);
        this.axios.post('/aql', queryInia)
            .then((response) => {
                let base64Pdf = response.data.get_diagnostico.data.diagnostic;
                var pdf_newTab = window.open("", "_blank");
                setTimeout(() => {
                    if (pdf_newTab) {
                        pdf_newTab.document.write(
                            "<html><head><title>Diagnóstico</title></head><body><iframe title='diagnostico' width='100%' height='100%' src='data:application/pdf;base64," + base64Pdf + "'></iframe></body></html>"
                        );
                    } else {
                        alert("O navegador bloqueou a abertura da nova aba. Habilite pop-ups para este site.");
                    }
                }, 500);
        }).finally(() => this.$store.commit('loading', false));
        
    },

    enviar_anexos() { 
        if ( this.files.find(item => item.ordem) ) { 
            this.files = this.files.sort((a, b) => a.ordem - b.ordem);
        }

        if ( this.files.find(item => item.link) )  {

            this.$util.atualizar(this, { 
            service: 'arquivo_links', 
            func: 'anexar_link',
            dados: { 
                lista: this.files.filter(item => item.link),
                ...this.parms
            },
            modal: this.modal_id,
            callback: () => {
                this.$emit("refresh");
            }
            });

            return;

        }

        this.$refs.upload.active = true
    },

    incluir_link () { 
      this.files.push({
        name: '',
        path: '',
        link: true, 
      });
    },

    toggle_lock (arq) { 
      if ( arq.st_tipo_especial == 'locked' ) {
        arq.st_tipo_especial = '';
      } else {
        arq.st_tipo_especial = 'locked';
      }

      this.$util.atualizar(this, {
        service: 'arquivo_links',
        dados: arq,
        toast: true,
        msg: 'Atualizado para ' +
          'SER exibido na galeria de imagens' + 
          ( arq.st_tipo_especial == 'locked' ? ' SOMENTE PARA MIM.' : '.' )
      });
    },

    get_download_link_jpg(arq) {
      return 'https://cert.klingo.app/valid/' + window.redir + '/' + arq.model_id + '/' + arq.arquivo.st_token + '?jpg=1';
    },

    ver_conteudo (lateral = false) {
        if ( this.files.length ) { 
            if ( !confirm('Existem arquivos/imagens selecionadas. Confirma o fechamento da janela, com o seu descarte?') ) { 
                return;
            }
        }
        
        this.$refs.preview.abrir(this.arquivos, lateral);
    },

    toggle_nopep (arq) {

      arq.st_tipo_especial == 'nopep' ? arq.st_tipo_especial = '' : arq.st_tipo_especial = 'nopep';

      this.$util.atualizar(this, {
        service: 'arquivo_links',
        dados: arq,
        toast: true,
        msg: 'Atualizado para ' +
          ( arq.st_tipo_especial == 'nopep' ? 'NÃO ' : '' ) +
          'SER exibido na galeria de imagens do prontuário.'
      });

    },

    compartilhar (arq) {
      if ( !confirm('Deseja enviar o documento selecionado por e-mail para o paciente?') ) {
        return;
      }

      this.$util.atualizar(this, {
        service: 'pacientes',
        func: 'share_file',
        dados: {
          id_paciente: this.parms.id_paciente,
          id_arquivo_link: arq.id_arquivo_link
        },
        callback: res => {
          if ( res.msg ) {
            this.$toast.add({
              severity: res.status ? res.status : 'success',
              summary: "Atenção",
              detail: res.msg,
              life: 3000
            });
          }
        }
      })
    },

    fechar() {
        if ( this.files.length ) { 
            if ( !confirm('Existem arquivos/imagens selecionadas. Confirma o fechamento da janela, com o seu descarte?') ) { 
                return;
            }
        }

        $('#' + this.modal_id).modal('hide');
    },

    // Métodos para Captura de Imagem

    onCapture() {
        this.img = this.$refs.webcam.capture();
    },

    onCaptureSelect() { 
        this.img = this.$refs.webcam.capture();
        this.selecionarCaptura();
    },

    onCaptureSelectSend() { 
        this.img = this.$refs.webcam.capture();
        this.selecionarCaptura();
        this.enviar_anexos(); 
    },

    onStarted(stream) {
        console.log("On Started Event", stream);
        this.opencam = true;
    },
    onStopped(stream) {
        console.log("On Stopped Event", stream);
        this.opencam = false;
    },
    onStop() {
        this.$refs.webcam.stop();
    },
    onStart() {
        this.$refs.webcam.start();
    },
    onError(error) {
        console.log("On Error Event", error);
    },
    onCameras(cameras) {
        this.devices = cameras;
        console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
        this.deviceId = deviceId;
        this.camera = deviceId;
        console.log("On Camera Change Event", deviceId);
    },

    selecionarCaptura () {
      //console.log(this.img);
      
      this.cont_captura = this.cont_captura + 1;

      let filename = 'image' + this.cont_captura + '.jpg';
      let dataurl = this.img;

      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);

      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }

      let novo = new File([u8arr], filename, {type:mime});

      this.$refs.upload.add(novo);

    },

    //
    remover_anexo(arq) {
      if (!confirm("Confirma remover o anexo?")) {
        return;
      }

      this.$util.atualizar(this, {
        service: "arquivos",
        func: "destroy",
        dados: {
          id: arq.id_arquivo_link
        },
        modal: this.modal_id,
        callback: () => {
          this.$emit("refresh");
        }
      });
    },

    viewFile(id) {
      this.$store.commit("loading", true);

      let dados = {
        id: id
      };

      this.axios
        .post("/arq", dados)
        .then(res => {
          window.open(res.data, "_blank");
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    },
    /**
     * Has changed
     * @param  Object|undefined   newFile   Read only
     * @param  Object|undefined   oldFile   Read only
     * @return undefined
     */
    inputFile: function(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        newFile.id_tipo_arquivo = '';
        // Get response data
        if (newFile.xhr) {
          //  Get the response status code
          console.log("status", newFile.xhr.status);
        }
      }
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter: function(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|gif|png|webp|tif|tiff|pdf|docx|xlsx|xml)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    },

    abrir(parms = null) {
        this.exibe_body = false;
        this.img = null;
        this.qrCode = null;
        this.cont_captura = 0;
        if (
            this.arquivos &&
            this.arquivos.length &&
            !this.arquivos.find(arq => arq.arquivo)
        ) {
            alert("Carregar Arquivos.");
            return;
        }

        this.files = [];

        this.$nextTick(() => {
            this.exibe_body = true;
        
            $("#" + this.modal_id).modal("show");

            if ( parms && parms.camera ) { 
                this.usewebcam = true;
            }

            if ( this.deviceId && this.usewebcam ) { 
                this.onCameraChange(null);

                this.$nextTick(() => {
                    this.onCameraChange(this.deviceId);
                });
            }
        });
    },

    async azUpload() {
      let formData = new FormData();

      this.$store.commit("loading", true);

      if (this.parms) {
        _.forEach(this.parms, function(element, key) {
          formData.append(key, element);
        });

        formData.append("multiple", true);
      }

      let tamanho_acc = 0;
      let blockupload = false;
      let enviado = false;

      this.files.forEach((arq, idx) => {

        if ( !this.envio_individual ) { 

            tamanho_acc += arq.file.size;
            if ( tamanho_acc > ( 1024 * 1024 * 10 ) ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "O tamanho máximo de upload de arquivos é de 10MB.",
                    life: 3000
                });

                blockupload = true;

                return;
            }

        }

        if ( this.envio_individual && enviado ) {
          return;
        }

        const fileType = arq.file.type;
        var blob = arq.file.slice(0, arq.file.size, fileType);
        var newFile = new File([blob], arq.name, { type: fileType });

        if(arq.id_tipo_arquivo) {
            formData.append(arq.name.replace(/[\s._\-()[\]{}]/g, '').toLowerCase(), arq.id_tipo_arquivo);
            formData.append('tp_' + idx, arq.id_tipo_arquivo);
        }

        if ( this.$refs.file_items ) { 
            formData.append('am', this.$refs.file_items.anexar_todas ? 1 : 0 );
        }
        
        // formData.append("files[]", arq.file);
        formData.append("files[]", newFile);

        enviado = true; 
      });

      if ( blockupload ) { 
        this.$store.commit("loading", false);
        return;
      }

      if ( this.envio_individual && this.files.length > 1 ) {
        //
      } else { 
        this.$refs.upload.clear();
      }

      //formData.append('file', file.file);
      let url =
        this.parms && this.parms.token
          ? "upload_arquivo_token"
          : "upload_arquivo_atendimento";

      return this.axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          return res;
        })
        .finally(() => {
          this.$store.commit("loading", true);

          if ( this.envio_individual && this.files.length > 1 ) {

            this.files.splice(0, 1);
            this.azUpload();

          } else {

            if ( this.$refs.upload ) { 
                this.$refs.upload.active = false;
                this.$refs.upload.clear();
            }

            if ( this.parms && ( this.parms.tipo_especial || this.parms.fechar_ao_enviar ) && !this.usewebcam ) {
                $("#" + this.modal_id).modal("hide");
            }

            this.$emit("refresh");

          }

        });
    },
    getIcon(filename) {
      if (!/\.(jpeg|jpe|jpg|gif|png|tif|tiff)$/i.test(filename)) {
        return "file-pdf";
      }

      return "file-image";
    },
    obterQrCode() {
      this.usewebcam = false;
      this.$store.commit("loading", true);

      this.axios
        .post("/fupload/token", { ...this.parms })
        .then(res => {
          if (res.response && res.response.status > 400) {
            this.status = res.response.data;
            this.$toast.add({
              severity: "error",
              summary: "Atenção",
              detail: res.response.data,
              life: 3000
            });
          } else {
            //console.log(res);
            this.$nextTick(() => {
              this.token = res.data.token;
              this.qrCode = res.data.link;
            });

            this.canal = this.$store.state.dominio + '-' + res.data.token + '-arq-celular';

            subscribe(this.canal, "recarregar-arquivo", () => {
              this.$emit("refresh");
            });

            //console.log('Modal', this.modal_id);

            $('#' + this.modal_id).on('hidden.bs.modal', () => {
              //console.log('Leaving...');
              //console.log('Leave Channel', this.canal);
              if ( this.canal ) {
                window.Echo.leaveChannel(this.canal);
              }
            });
          }
        })
        .catch(err => {
          alert(err);
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    },

  },
  
  beforeMount() {
    this.chave_modal = this.$util.uuidv4();
  },

  mounted() {
    this.qrCode = null;
    document.onpaste = pasteEvent => {
      // consider the first item (can be easily extended for multiple items)
      var item = pasteEvent.clipboardData.items[0];

      if (item.type.indexOf("image") === 0) {
        var blob = item.getAsFile();

        if ( this.$refs.upload ) { 
            this.$refs.upload.add(blob);
        } else { 
            console.log('Upload não encontrado.');
        }
      }
    };

    $('#' + this.modal_id).on('hidden.bs.modal', () => {
        if ( ($("#" + this.modal_id).data('bs.modal') || {})._isShown ) { 
            console.log('Quase Fechou Modal camera');
        } else { 
            console.log('Fechou Modal camera');
            this.usewebcam = false;
        }
    });
  }
};
</script>
